import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"

export const ItemWrapper = styled.div`
  width: 100%;
  margin: 1rem 0;

  ${minWidth.tablet`
    width: 47.5%;
  `}
`

export const Category = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.714;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const TitleLink = styled.a`
  font-size: 1.6rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.5;
  color: #b5471f;
`

export const ReviewLink = styled.a`
  width: fit-content;
  display: block;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.625;
`

export const ArrowIcon = styled(Icon)`
  position: relative;
  top: 0.3rem;
  left: 0.5rem;
`
